/* GlassesBD Theme JS v4 — Simplified */
(function(){
'use strict';

/* ── Cart Drawer ── */
var autoCloseTimer = null;

window.openCartDrawer = function(autoClose){
  var el = document.getElementById('cart-drawer');
  if(!el) return;
  el.classList.add('cart-drawer--open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
  if(autoClose){
    clearTimeout(autoCloseTimer);
    autoCloseTimer = setTimeout(function(){ closeCartDrawer() }, 3000);
  }
};

window.closeCartDrawer = function(){
  clearTimeout(autoCloseTimer);
  var el = document.getElementById('cart-drawer');
  if(el) el.classList.remove('cart-drawer--open');
  document.body.style.overflow = '';
};

function refreshCartDrawer(){
  fetch('/cart.js').then(function(r){ return r.json() }).then(function(cart){
    updateCartCount(cart.item_count);
    var cdc = document.getElementById('cd-count');
    if(cdc) cdc.textContent = cart.item_count;
    var foot = document.getElementById('cd-foot');
    var fmt = function(p){ return '৳' + Math.round(p/100).toLocaleString('en-IN') };

    if(cart.item_count === 0){
      document.getElementById('cd-body').innerHTML = '<div class="cd-empty"><div style="font-size:32px;margin-bottom:8px">🛒</div><p>Your cart is empty</p></div>';
      if(foot) foot.style.display = 'none';
    } else {
      if(foot) foot.style.display = '';
      var tp = document.getElementById('cd-total-price');
      if(tp) tp.textContent = fmt(cart.total_price);
      var cp = document.getElementById('cd-checkout-price');
      if(cp) cp.textContent = fmt(cart.total_price);

      var h = '';
      cart.items.forEach(function(item){
        h += '<div class="cd-item" data-key="' + item.key + '"><div class="cd-item__img">';
        if(item.image) h += '<img src="' + item.image.replace(/(\.\w+)$/, '_150x$1') + '" alt="" loading="lazy">';
        h += '</div><div class="cd-item__info">';
        h += '<a href="' + item.url + '" class="cd-item__name">' + item.product_title + '</a>';
        if(item.variant_title && item.variant_title !== 'Default Title'){
          h += '<div class="cd-item__var">' + item.variant_title + '</div>';
        }
        if(item.properties && Object.keys(item.properties).length > 0){
          h += '<div class="cd-item__props">';
          for(var k in item.properties){
            if(k.charAt(0) !== '_') h += '<span>' + k + ': ' + item.properties[k] + '</span>';
          }
          h += '</div>';
        }
        h += '<div class="cd-item__bottom"><span class="cd-item__price">' + fmt(item.final_line_price) + '</span>';
        h += '<button class="cd-item__rm" onclick="removeCartItem(\'' + item.key + '\')">Remove</button>';
        h += '</div></div></div>';
      });
      document.getElementById('cd-body').innerHTML = h;
    }
  }).catch(function(){});
}

window.removeCartItem = function(key){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(function(){ refreshCartDrawer() }).catch(function(){});
};

/* ── Add to Cart Quick (with auto-box support) ── */
window.addToCartQuick = function(variantId, btn, evt){
  if(evt){ evt.preventDefault(); evt.stopPropagation() }
  var origHTML = btn.innerHTML;
  btn.innerHTML = 'Adding...';
  btn.disabled = true;

  var items = [{ id: parseInt(variantId), quantity: 1 }];

  // Check for auto_box from button data attribute or hidden input
  var boxId = btn.dataset && btn.dataset.box ? btn.dataset.box : null;
  if(!boxId){
    var boxInput = document.getElementById('pp-auto-box');
    if(boxInput) boxId = boxInput.value;
  }
  if(boxId && parseInt(boxId)){
    items.push({ id: parseInt(boxId), quantity: 1 });
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r){ if(!r.ok) throw new Error('fail'); return r.json() })
  .then(function(){
    btn.innerHTML = '✓ Added!';
    btn.classList.add('p-card__atc--added');
    updateCartCount(null);
    openCartDrawer(true);
    setTimeout(function(){
      btn.innerHTML = origHTML;
      btn.disabled = false;
      btn.classList.remove('p-card__atc--added');
    }, 2000);
  })
  .catch(function(){
    btn.innerHTML = origHTML;
    btn.disabled = false;
    alert('Could not add to cart');
  });
};

/* ── Cart Count ── */
function updateCartCount(count){
  if(count === null){
    fetch('/cart.js').then(function(r){ return r.json() }).then(function(c){ setCount(c.item_count) });
  } else {
    setCount(count);
  }
}
function setCount(n){
  document.querySelectorAll('.cart-count').forEach(function(el){
    el.textContent = n;
    el.style.display = n > 0 ? 'flex' : 'none';
  });
  var cdc = document.getElementById('cd-count');
  if(cdc) cdc.textContent = n;
}
window.updateCartCount = updateCartCount;

/* ── Product Slider ── */
window.slideCollection = function(btn, dir){
  var sec = btn.closest('section') || btn.closest('.sec');
  var track = sec ? sec.querySelector('.p-slider__track') : null;
  if(!track) return;
  var slide = track.querySelector('.p-slider__slide');
  if(!slide) return;
  track.scrollBy({ left: dir * (slide.offsetWidth + 12) * 2, behavior: 'smooth' });
};

/* ── Color Group Population (product cards) ── */
function populateColorGroups(){
  var groups = {};
  document.querySelectorAll('.p-card__colors[data-cg]').forEach(function(el){
    var cg = el.dataset.cg, handle = el.dataset.current;
    if(!groups[cg]) groups[cg] = [];
    var sw = el.querySelector('.p-card__swatch');
    if(sw) groups[cg].push({ el: el, handle: handle, color: sw.style.background, title: sw.title });
  });
  for(var cg in groups){
    var items = groups[cg];
    if(items.length <= 1) continue;
    items.forEach(function(item){
      item.el.innerHTML = '';
      items.forEach(function(sib){
        var a = document.createElement('a');
        a.href = '/products/' + sib.handle;
        a.className = 'p-card__swatch' + (sib.handle === item.handle ? ' p-card__swatch--active' : '');
        a.style.background = sib.color;
        a.title = sib.title;
        a.onclick = function(e){ e.stopPropagation() };
        item.el.appendChild(a);
      });
    });
  }
}

/* ── Announcement Bar — hide on scroll down, show on scroll up ── */
(function(){
  var ann = document.querySelector('.ann-bar');
  if(!ann) return;
  var lastY = 0, ticking = false;
  window.addEventListener('scroll', function(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      var y = window.scrollY;
      if(y > 60 && y > lastY){
        ann.classList.add('ann-bar--hidden');
      } else {
        ann.classList.remove('ann-bar--hidden');
      }
      lastY = y;
      ticking = false;
    });
  }, { passive: true });
})();

/* ── Keyboard shortcuts ── */
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){
    var mn = document.getElementById('mob-nav');
    if(mn) mn.classList.remove('mob-nav--open');
    var fd = document.getElementById('filter-drawer');
    if(fd) fd.classList.remove('filter-drawer--open');
    closeCartDrawer();
    if(typeof LensSelector !== 'undefined') LensSelector.close();
    document.body.style.overflow = '';
  }
});

/* ── Init ── */
document.addEventListener('DOMContentLoaded', function(){
  // Intercept cart link to open drawer instead
  var cartBtn = document.querySelector('.hdr__acts a[href$="/cart"]');
  if(cartBtn){
    cartBtn.addEventListener('click', function(e){
      e.preventDefault();
      openCartDrawer(false);
    });
  }
  populateColorGroups();
});

/* ── Mobile Nav Toggle ── */
window.toggleMobileNav = function(){
  var mn = document.getElementById('mob-nav');
  if(mn) mn.classList.toggle('mob-nav--open');
};

})();
